import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useChangePasswordStore = defineStore('changePasswordStore', () => {
  const hasSentLinkSuccess = ref(false)
  const hasChangedPasswordSuccess = ref(false)

  const setHasSentLinkSuccess = (payload) => {
    hasSentLinkSuccess.value = payload
  }

  const setHasChangedPasswordSuccess = (payload) => {
    hasChangedPasswordSuccess.value = payload
  }

  return {
    hasSentLinkSuccess,
    hasChangedPasswordSuccess,
    setHasSentLinkSuccess,
    setHasChangedPasswordSuccess
  }
})
